import React from "react";
import { connect } from "react-redux";
import CompteEntreprise from "Components/Modal/ModalCreationCompte/CompteEntreprise/CompteEntreprise";
import PropTypes from "prop-types";

const InscriptionEntrepriseForm = (props) => {
  return (
    <React.Fragment>
      <CompteEntreprise
        setAuthEntrepriseVisible={props.setAuthEntrepriseVisible}
      />
    </React.Fragment>
  );
};

InscriptionEntrepriseForm.propTypes = {
  setAuthEntrepriseVisible: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InscriptionEntrepriseForm);
